import {
  GET_ORDER,
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  GET_ORDER_SUMMARY,
  GET_ORDER_SUMMARY_SUCCESS,
  GET_ORDER_SUMMARY_ERROR,
  COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT,
  COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_SUCCESS,
  COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_ERROR,
  GET_ORDER_SUMMARY_CONFIRMATION,
  GET_ORDER_SUMMARY_CONFIRMATION_SUCCESS,
  GET_ORDER_SUMMARY_CONFIRMATION_ERROR,
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_ERROR
} from "../actions";

const INIT_STATE = {
  orderId: null,
  contactId: null,
  order: [],
  orderSummary: null,
  orderDetailsError: "",
  completionOfAdditionalStepsLoading: false,
  completionStatusOfAdditionalSteps: null,
  completionOfAdditionalStepsError: "",
  orderConfirmation : "",
  progressIcon: false,
  orderDetailsLoading : false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ORDER_SUMMARY:
      return { ...state, loading: true,isSagaExecuted: false, progressIcon:true,orderDetailsLoading:true, orderId: action.payload.orderId, contactId: action.payload.contactId };
    case GET_ORDER_SUMMARY_SUCCESS:
      return { ...state, loading: false,isSagaExecuted: false, progressIcon : false, orderDetailsLoading:false, orderSummary: action.payload.orderSummary };
    case GET_ORDER_SUMMARY_ERROR:
      return { ...state, loading: false,isSagaExecuted: false, orderDetailsError: action.payload ? action.payload.message : "", progressIcon : false, orderDetailsLoading:false, };
    case GET_ORDER_SUMMARY_CONFIRMATION:
      return { ...state, loading: true, orderId: action.payload.orderId, progressIcon : true };
    case GET_ORDER_SUMMARY_CONFIRMATION_SUCCESS:
      return { ...state, loading: false, orderConfirmation: action.payload, progressIcon : false };
    case GET_ORDER_SUMMARY_CONFIRMATION_ERROR:
      return { ...state, loading: false, orderDetailsError: action.payload ? action.payload.message : "", progressIcon : false };      
    case COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT:
      return { ...state, completionOfAdditionalStepsLoading: true, completionOfAdditionalStepsError: "", completionStatusOfAdditionalSteps: null};
    case COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_SUCCESS:
      return { ...state, completionOfAdditionalStepsLoading: false, completionStatusOfAdditionalSteps: action.payload.completionStatusOfAdditionalSteps };
    case COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT_ERROR:
      return { ...state, completionOfAdditionalStepsLoading: false, completionOfAdditionalStepsError: action.payload ? action.payload.message : "" };
    case GET_ORDER:
      return { ...state, loading: true, orderDetailsError: "", orderId: action.payload.orderId };
    case GET_ORDER_SUCCESS:
      return { ...state, loading: false, orderDetailsError: "", order: action.payload.order };
    case GET_ORDER_ERROR:
      return { ...state, loading: false, orderDetailsError: action.payload ? action.payload.message : "" };
    case UPDATE_ORDER:
      return { ...state, loading: true, orderDetailsError: "", order: action.payload.order };
    case UPDATE_ORDER_SUCCESS:
      let updatedOrderSummary = { ...state.orderSummary };
      updatedOrderSummary.orderResponse = {...updatedOrderSummary.orderResponse, shippingContactBlockId: action.payload.order.shippingContactBlockId, billingContactBlockId: action.payload.order.billingContactBlockId} ;
      return { ...state, loading: false, orderDetailsError: "", order: action.payload.order, orderSummary: updatedOrderSummary };
    case UPDATE_ORDER_ERROR:
      return { ...state, loading: false, orderDetailsError: action.payload ? action.payload.message : "" };      
    default:
      return { ...state };
  }
};